/**
 * Created by Ning Jiang on 11/16/2018.
 */

import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {IReelStoppedData} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {ReelStopPresentationController} from "@nolimitcity/slot-game/bin/core/reelstoppresentation/ReelStopPresentationController";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {TimelineLite} from "gsap";
import {TombstoneGameMode} from "../../gamemode/TombstoneGameMode";
import {TombstoneParsedGameData} from "../../server/data/TombstoneParsedGameData";
import {TombstoneSoundConfig} from "../../TombstoneSoundConfig";
import {FreespinRetriggerView} from "./FreespinRetriggerView";

export class FreespinRetriggerController extends ReelStopPresentationController {

    private _isFreespinMode:boolean;
    private _scatterPositions:number[];
    private _shouldUpdateKeypad:boolean = false;
    private _fsLeft:number;

    private _view:FreespinRetriggerView;

    constructor(index:number) {
        super(index, "freespinRetrigger");

        this._view = new FreespinRetriggerView();
    }

    protected parseFeatureGameData(data:TombstoneParsedGameData):void {
        this._isFreespinMode = data.mode === GameMode.FREESPIN || data.mode === TombstoneGameMode.SUPER_FREESPIN;
        this._scatterPositions = data.scatterPositions!;
        this._fsLeft = data.freespinsLeft;
    }

    public onReelBounce(data:IReelStoppedData):void {
        if(!this._isFreespinMode) {
            this.dispatchCompleteEvent(data.reelId);
            return;
        }

        if(data.reelId === 4) {
            const timeline:TimelineLite = new TimelineLite({paused : true});
            if(this._scatterPositions[0] > -1) {
                timeline.add(this._view.getReelRetriggerTimeline(0, this._scatterPositions[0], 1), 0.5);
                this._shouldUpdateKeypad = true;
            }
            if(this._scatterPositions[4] > -1) {
                timeline.add(this._view.getReelRetriggerTimeline(4, this._scatterPositions[4], this._shouldUpdateKeypad ? 2 : 1), 0.5);
                this._shouldUpdateKeypad = true;
            }
            if(this._shouldUpdateKeypad) {
                timeline.add(() => SlotGame.sound.playEffect(TombstoneSoundConfig.instance.FSPlusOne), 0.5);
            }
            timeline.add(() => {
                if(this._shouldUpdateKeypad) {
                    SlotGame.keypad.setZeroBetSpinCounter(this._fsLeft);
                    this._shouldUpdateKeypad = false;
                }
            });
            timeline.add(() => this.dispatchCompleteEvent(data.reelId), `+=${this._shouldUpdateKeypad ? 0.2 : 0}`);
            timeline.play();
            return;
        }

        this.dispatchCompleteEvent(data.reelId);
    }

    public onReelSpinStopped(data:IReelStoppedData):void {
        if(!data.active) {
            this.dispatchCompleteEvent(data.reelId);
        }
    }

    protected resetFeature():void {
        this._shouldUpdateKeypad = false;
    }
}